<script>

  import Layout from "../../layouts/main";
  import PageHeader from "../../components/page-header";
  import pagination from "laravel-vue-pagination";
  import ChowmanPayList from './chowman-pay-list';
  /**
   * Customers component
   */
  export default {
    components: { Layout, PageHeader, pagination, ChowmanPayList},
    data() {
      return {
		extraColumns: [{ key: "action", label: this.trans.get("__JSON__.Action"), sortable: true, }]
	  };
	  
    }, 
  };

</script>

<template>
  <Layout>
    <chowman-pay-list :extra-columns="extraColumns"/>
  </Layout>
</template>
